import React from 'react';
import PropTypes from 'prop-types';
import { useAddressFormContext } from '../context';
import { isEmptyAddress } from '../helpers';
import { ReadOnlyEmptyFields } from './read-only-empty-fields';

import { AUFields } from './AU';
import { CAFields } from './CA';
import { DefaultFields } from './default';
import { FRFields } from './FR';
import { GBFields } from './GB';
import { NZFields } from './NZ';
import { USFields } from './US';
import { DEFields } from './DE';

const readOnlyFieldsByCountry = {
  AU: AUFields,
  CA: CAFields,
  FR: FRFields,
  GB: GBFields,
  NZ: NZFields,
  US: USFields,
  DE: DEFields,
};

const ReadOnlyCountryFields = ({ style }) => {
  const { address, recipientInfo } = useAddressFormContext();
  const isEmpty = isEmptyAddress(address);
  if (isEmpty) {
    return (
      <ReadOnlyEmptyFields
        company={address.company}
        country={address.countryCode}
        email={recipientInfo.email}
        name={address.name}
        phone={address.phone}
        style={style}
      />
    );
  }
  const ReadOnlyFieldsForCountry = readOnlyFieldsByCountry[address?.countryCode] || DefaultFields;

  return <ReadOnlyFieldsForCountry style={style} />;
};
ReadOnlyCountryFields.propTypes = {
  style: PropTypes.string,
};
export { ReadOnlyCountryFields };
